import { Core } from "@faire/design-tokens";
export var linkHoverColor = Core.text.hover;
export var topBarBackgroundColor = Core.surface.default;
